import { clientPath, lpRequest } from '../../../../core/utils/lp-backend';
import { getUser } from './get-user';

/** `PATCH /client/:cid/users/:id {firstname, lastname}`. */
export const editUser = async (
  user_id: string,
  firstname: string,
  lastname: string
): Promise<any> => {
  await lpRequest('PATCH', clientPath(`/users/${user_id}`), { body: { firstname, lastname } });

  return getUser(user_id);
};
